import React from 'react';
import { BrandIcon } from '@tt/ui';
import cx from 'classnames';
import PropTypes from 'prop-types';

import styles from './PaymentCardsList.module.scss';

const PaymentCardsList = ({ className }) => (
  <div className={cx(styles.container, className)}>
    <BrandIcon name="visa" size="xl" />
    <BrandIcon name="amex" size="xl" />
    <BrandIcon name="discover" size="xl" />
    <BrandIcon name="mastercard" size="xl" />
  </div>
);

PaymentCardsList.propTypes = {
  className: PropTypes.string,
};

export default PaymentCardsList;
